class ReiandoServicePage {
  constructor(section) {
    this.section = section;

    this.wrappingToggle = section.querySelector(
      '[data-reiando-wrapping-toggle]'
    );

    this.wrappingContent = section.querySelector(
      '[data-reiando-wrapping-content]'
    );

    this.isWrappingOpen = false;
    this.scrollTimer = null;
    this.animationFrame = null;
    this.initialScrollTimer = null;
    this.initialScrollFrame = null;

    this.handleWrappingToggle =
      this.handleWrappingToggle.bind(this);

    this.handleTransitionEnd =
      this.handleTransitionEnd.bind(this);

    this.bindEvents();
    this.updateWrappingState(false, false);
    this.scheduleInitialSectionScroll();
  }


  /*
   * イベント登録
   */
  bindEvents() {
    this.wrappingToggle?.addEventListener(
      'click',
      this.handleWrappingToggle
    );

    this.wrappingContent?.addEventListener(
      'transitionend',
      this.handleTransitionEnd
    );
  }


  /*
   * 別ページから指定されたSERVICE位置へ移動
   */
  scheduleInitialSectionScroll() {
    const url = new URL(
      window.location.href
    );

    const targetId =
      url.searchParams.get('scroll_to');

    const targetSelectors = {
      'initial-embroidery':
        '#initial-embroidery',
      'gift-package':
        '#gift-package, .service_section_gift'
    };

    const targetSelector =
      targetSelectors[targetId];

    if (!targetSelector) {
      return;
    }

    const target =
      document.querySelector(
        targetSelector
      );

    if (!target) {
      return;
    }

    /*
     * ギフト包装セクションにIDが未設定でも、
     * 移動後のURLを#gift-packageへ整えられるようにする
     */
    if (!target.id) {
      target.id = targetId;
    }

    /*
     * ブラウザのスクロール位置復元を避け、
     * SERVICEページ上部から自然に移動させる
     */
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });

    this.cancelInitialScroll();

    this.initialScrollFrame =
      window.requestAnimationFrame(() => {
        this.initialScrollFrame =
          window.requestAnimationFrame(() => {
            this.initialScrollTimer =
              window.setTimeout(() => {
                this.scrollToServiceTarget(
                  target,
                  targetId
                );

                this.initialScrollTimer =
                  null;
              }, 120);

            this.initialScrollFrame = null;
          });
      });
  }


  /*
   * SERVICE内の指定位置へスクロール
   */
  scrollToServiceTarget(
    target,
    targetId
  ) {
    const marginTop = 20;

    const targetPosition =
      window.scrollY +
      target.getBoundingClientRect().top -
      this.getFixedHeaderOffset() -
      marginTop;

    window.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: this.prefersReducedMotion()
        ? 'auto'
        : 'smooth'
    });

    this.replaceScrollQueryWithHash(
      targetId
    );
  }


  /*
   * 移動後のURLを通常のページ内リンク形式へ整える
   */
  replaceScrollQueryWithHash(targetId) {
    const url = new URL(
      window.location.href
    );

    url.searchParams.delete(
      'scroll_to'
    );

    url.hash = targetId;

    window.history.replaceState(
      window.history.state,
      '',
      `${url.pathname}${url.search}${url.hash}`
    );
  }


  /*
   * 固定・追従ヘッダー分の高さを取得
   */
  getFixedHeaderOffset() {
    const header = document.querySelector(
      '[data-reiando-header]'
    );

    if (!header) {
      return 0;
    }

    const headerPosition =
      window.getComputedStyle(
        header
      ).position;

    if (
      headerPosition !== 'fixed' &&
      headerPosition !== 'sticky'
    ) {
      return 0;
    }

    return header.getBoundingClientRect()
      .height;
  }


  /*
   * 包み方の開閉
   */
  handleWrappingToggle() {
    const nextState =
      !this.isWrappingOpen;

    this.updateWrappingState(
      nextState,
      true
    );

    /*
     * 開いたときだけ、
     * 展開内容の先頭へスクロール
     */
    if (nextState) {
      this.scheduleWrappingScroll();
    }
  }


  /*
   * 包み方の表示状態を反映
   */
  updateWrappingState(
    isOpen,
    shouldAnimate = true
  ) {
    if (
      !this.wrappingToggle ||
      !this.wrappingContent
    ) {
      return;
    }

    this.isWrappingOpen = isOpen;

    this.wrappingToggle.classList.toggle(
      'is_open',
      isOpen
    );

    this.wrappingToggle.setAttribute(
      'aria-expanded',
      isOpen ? 'true' : 'false'
    );

    this.wrappingContent.setAttribute(
      'aria-hidden',
      isOpen ? 'false' : 'true'
    );

    this.wrappingToggle.textContent =
      isOpen
        ? '包み方を閉じる'
        : '包み方を見る';

    if (!shouldAnimate) {
      this.wrappingContent.classList.toggle(
        'is_open',
        isOpen
      );

      this.wrappingContent.style.height =
        isOpen ? 'auto' : '0px';

      return;
    }

    if (isOpen) {
      this.openWrappingContent();
    } else {
      this.closeWrappingContent();
    }
  }


  /*
   * 包み方をぬるっと開く
   */
  openWrappingContent() {
    this.cancelAnimationFrame();

    this.wrappingContent.classList.add(
      'is_open'
    );

    if (this.prefersReducedMotion()) {
      this.wrappingContent.style.height =
        'auto';

      return;
    }

    this.wrappingContent.style.height =
      '0px';

    /*
     * 開いた状態のpaddingを反映させてから
     * 必要な高さを取得する
     */
    void this.wrappingContent.offsetHeight;

    this.animationFrame =
      window.requestAnimationFrame(() => {
        const targetHeight =
          this.wrappingContent.scrollHeight;

        this.wrappingContent.style.height =
          `${targetHeight}px`;

        this.animationFrame = null;
      });
  }


  /*
   * 包み方をぬるっと閉じる
   */
  closeWrappingContent() {
    this.cancelAnimationFrame();

    if (this.prefersReducedMotion()) {
      this.wrappingContent.classList.remove(
        'is_open'
      );

      this.wrappingContent.style.height =
        '0px';

      return;
    }

    const currentHeight =
      this.wrappingContent.scrollHeight;

    this.wrappingContent.style.height =
      `${currentHeight}px`;

    /*
     * 現在の高さを確定してから
     * 0pxまで縮める
     */
    void this.wrappingContent.offsetHeight;

    this.wrappingContent.classList.remove(
      'is_open'
    );

    this.animationFrame =
      window.requestAnimationFrame(() => {
        this.wrappingContent.style.height =
          '0px';

        this.animationFrame = null;
      });
  }


  /*
   * 開くアニメーション完了後は
   * 高さをautoへ戻す
   */
  handleTransitionEnd(event) {
    if (
      event.target !==
        this.wrappingContent ||
      event.propertyName !== 'height'
    ) {
      return;
    }

    if (this.isWrappingOpen) {
      this.wrappingContent.style.height =
        'auto';
    }
  }


  /*
   * 展開開始後、少し待ってからスクロール
   */
  scheduleWrappingScroll() {
    if (!this.wrappingContent) {
      return;
    }

    if (this.scrollTimer) {
      window.clearTimeout(
        this.scrollTimer
      );
    }

    this.scrollTimer =
      window.setTimeout(() => {
        this.scrollToWrappingContent();
        this.scrollTimer = null;
      }, 100);
  }


  /*
   * 展開内容の先頭へスクロール
   */
  scrollToWrappingContent() {
    if (
      !this.wrappingContent ||
      !this.isWrappingOpen
    ) {
      return;
    }

    const marginTop = 20;

    const targetPosition =
      window.scrollY +
      this.wrappingContent
        .getBoundingClientRect()
        .top -
      this.getFixedHeaderOffset() -
      marginTop;

    window.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: this.prefersReducedMotion()
        ? 'auto'
        : 'smooth'
    });
  }


  /*
   * アニメーション軽減設定
   */
  prefersReducedMotion() {
    return window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
  }


  /*
   * requestAnimationFrame解除
   */
  cancelAnimationFrame() {
    if (!this.animationFrame) {
      return;
    }

    window.cancelAnimationFrame(
      this.animationFrame
    );

    this.animationFrame = null;
  }


  /*
   * 初回スクロール処理解除
   */
  cancelInitialScroll() {
    if (this.initialScrollTimer) {
      window.clearTimeout(
        this.initialScrollTimer
      );

      this.initialScrollTimer = null;
    }

    if (this.initialScrollFrame) {
      window.cancelAnimationFrame(
        this.initialScrollFrame
      );

      this.initialScrollFrame = null;
    }
  }


  /*
   * イベント解除
   */
  destroy() {
    this.wrappingToggle?.removeEventListener(
      'click',
      this.handleWrappingToggle
    );

    this.wrappingContent?.removeEventListener(
      'transitionend',
      this.handleTransitionEnd
    );

    if (this.scrollTimer) {
      window.clearTimeout(
        this.scrollTimer
      );

      this.scrollTimer = null;
    }

    this.cancelAnimationFrame();
    this.cancelInitialScroll();
  }
}


/*
 * SERVICEセクションを初期化
 */
function initializeReiandoServicePage(
  root = document
) {
  const sections = [];

  if (
    root instanceof Element &&
    root.matches(
      '[data-reiando-service-page]'
    )
  ) {
    sections.push(root);
  }

  root
    .querySelectorAll?.(
      '[data-reiando-service-page]'
    )
    .forEach((section) => {
      sections.push(section);
    });

  sections.forEach((section) => {
    if (
      section.dataset
        .reiandoServiceInitialized ===
      'true'
    ) {
      return;
    }

    section.dataset
      .reiandoServiceInitialized =
      'true';

    section.reiandoServicePage =
      new ReiandoServicePage(section);
  });
}


/*
 * 通常ページ読み込み
 */
document.addEventListener(
  'DOMContentLoaded',
  () => {
    initializeReiandoServicePage();
  }
);


/*
 * Shopifyテーマエディター
 */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeReiandoServicePage(
      event.target
    );
  }
);


document.addEventListener(
  'shopify:section:unload',
  (event) => {
    const section =
      event.target.matches?.(
        '[data-reiando-service-page]'
      )
        ? event.target
        : event.target.querySelector(
            '[data-reiando-service-page]'
          );

    if (!section?.reiandoServicePage) {
      return;
    }

    section.reiandoServicePage.destroy();

    section.dataset
      .reiandoServiceInitialized =
      'false';

    delete section.reiandoServicePage;
  }
);
